import axios from 'axios'
import testWorkspace from '../test/testWorkspace.js'
import {TaskScheduler} from '../utils/taskScheduler'
import {elementFromObjectPath, fillPlaceholdersJson} from '../utils/general'
import civiiChatStore from '@/civii-chat/store/civiiChatStore.js'

var initialTimeoutID = null
// eslint-disable-next-line
var lastMsgTimeoutId = null

function handleCiviiStatusChange(commit, isCiviiActive, timeout) {
    // ENCIENDE O APAGA CIVII
    if(isCiviiActive == "S"){
        //if(isCiviiActive == "S" && !window.civii.$store.enable){
            commit('setEnable', true)
            window.civii.$store.dispatch('initStore')
            window.civii.show()
    } else {
        commit('setEnable', false)
        if (timeout === 0){
            window.civii.close()
        } else {
            // SI SE ESTA CHATEANDO SE USA MENSAJE DE AVISO
            commit('setLoading', true)
            commit('addMessage', {
                type: 'Normal',
                side: 'left',
                messages: [
                    { text: window.civiiConf.onTurnedOffStatusMessage }
                ]
            })
            setTimeout(() => {
                commit('setLoading', false)
                window.civii.close()
            }, timeout)
        }
    }
}

async function executeActions ({actionsList, commit, output, actions}) {
    for (let api of actionsList) {
        if (typeof api === 'string'){
            api = {name: api}
        }
        let {el, exists} = elementFromObjectPath(actions, api.name)
        if (exists){
            output = await el({args: api.args, output})
        } else {
            commit('setLoading', false)
            console.error('civii function not found')
            return false
        }
    }
    return output
}

function checkWeakUnderstanding(commit, rawIntents) {
    try {
        // let weakUnderstandingPercentajeLimit = window.civiiConf.civiiChat.weakUnderstandingPercentajeLimit;
        // let intents = JSON.parse(rawIntents);
        // let maxConfidencePercentaje = Math.max(intents.map( intent => intent.confidence), 0);
        // let haveWeakUnderstanding = parseInt(maxConfidencePercentaje * 100) <= weakUnderstandingPercentajeLimit;
        // if(haveWeakUnderstanding){
        //     commit('increaseWeakUnderstandingResponses');
        // } else {
        //     commit('resetWeakUnderstandingResponses');
        // }
    } catch(e) {}
}

export let storeBase = {
    state: {
        weakUnderstandingResponses: 0,
        talkingWithAgent: false,
        chatIsOpen: false,
        messages: [],
        context: {},
        buttons: [],
        accordionChecklist: {},
        calendarWidget: null,
        cancelAccept: null,
        cameraWidget: null,
        uploadWidget: null,
        loading: false,
        sound: true,
        firstTime: false,
        bubbleMessage: null,
        showChat: false,
        messagesStack: [],
        taskSch: null,
        firstBubbleClosed: false,
        selfLinkClicked: false,
        disableInput: false,
        enable: true
    },
    mutations: {
        increaseWeakUnderstandingResponses(state){
            state.weakUnderstandingResponses += 1;
        },
        resetWeakUnderstandingResponses(state){
            state.weakUnderstandingResponses = 0;
        },
        talktoAgent (state, value){
            state.talkingWithAgent = value;
        },
        setChatState (state, value) {
            state.chatIsOpen = value
            localStorage.setItem('civiiIsOpen', value)
        },
        setMessages (state, {value, noLocalStorage}) {
            state.messages = value
            if (!noLocalStorage){
                localStorage.setItem('civiiMessages', JSON.stringify(state.messages))
            }
        },
        addMessage (state, value) {
            let lastMessage = Object.assign({}, state.messages[state.messages.length - 1])
            if (lastMessage.type === 'Normal' && value.type === 'Normal' && lastMessage.side === value.side) {
                lastMessage.messages.push(...value.messages)
                state.messages.splice(state.messages.length - 1, 1, lastMessage)
            } else {
                state.messages.push(value)
            }
            localStorage.setItem('civiiMessages', JSON.stringify(state.messages))
        },
        addToContext (state, value) {
            state.context = Object.assign(state.context, value)
            localStorage.setItem('civiiContext', JSON.stringify(state.context))
        },
        setContext (state, value) {
            state.context = value
            localStorage.setItem('civiiContext', JSON.stringify(state.context))
        },
        setButtons (state, value) {
            state.buttons = value
            localStorage.setItem('civiiButtons', JSON.stringify(value))
        },
        setLoading (state, value) {
            state.loading = value
        },
        toggleSound (state) {
            state.sound = !state.sound
            localStorage.setItem('civiiSound', state.sound)
        },
        setSound (state, value) {
            state.sound = value
            localStorage.setItem('civiiSound', state.sound)
        },
        setFirstTime (state, value) {
            state.firstTime = value
        },
        setBubbleMessage (state, value) {
            state.bubbleMessage = value
        },
        setShowChat (state, value) {
            state.showChat = value
        },
        setTimeoutID (state, value) {
            state._timeoutID = value
        },
        setTimeoutIntervalID (state, value) {
            state._timeoutIntervalID = value
        },
        setTaskSch (state, value) {
            state.taskSch = value
        },
        setFirstBubbleClosed (state, value) {
            state.firstBubbleClosed = value
            localStorage.setItem('civiiFirstBubbleClosed', state.firstBubbleClosed)
        },
        setSelfLinkClicked (state, value) {
            state.selfLinkClicked = value
            localStorage.setItem('civiiSelfLinkClicked', state.selfLinkClicked)
        },
        setAccordionChecklist (state, value) {
            state.accordionChecklist = value
            localStorage.setItem('civiiAccordionChecklist', JSON.stringify(value))
        },
        setCalendarWidget (state, value) {
            state.calendarWidget = value
            localStorage.setItem('civiiCalendarWidget', JSON.stringify(value))
        },
        setCancelAccept (state, value) {
            state.cancelAccept = value
            localStorage.setItem('civiiCancelAccept', JSON.stringify(value))
        },
        setCameraWidget (state, value) {
            state.cameraWidget = value
            localStorage.setItem('civiiCameraWidget', JSON.stringify(value))
        },
        setUploadWidget (state, value) {
            state.uploadWidget = value
            localStorage.setItem('civiiUploadWidget', JSON.stringify(value))
        },
        setDisableInput (state, value) {
            state.disableInput = value
            localStorage.setItem('civiiDisableInput', JSON.stringify(value))
        },
        setEnable (state, value) {
            state.enable = value;
        },
        setContextLoggeado( state, value){
            state.context['loggeado'] = value;
            localStorage.setItem('civiiContext', JSON.stringify(state.context))
        }
    },
    actions: {
        getCiviiStatus({commit}, timeout) {
            if(!window.civiiConf.isAlwaysActive) {
                timeout = timeout || 0

                // CONSULTA EL ESTADO DE CIVII
                let parametros = {
                    workspace: window.civiiConf.workspace,
                    serviceName: "civii"
                }

                axios.post(window.civiiConf.baseURL + '/civii/Chatbot/obtenerEstadoCivii', parametros)
                .then(response => {
                    //window.civiiConf.workspaceId = response.data.workspaceId
                    handleCiviiStatusChange(commit, response.data.active, timeout)
                }).catch(error => {
                    console.log(error)
                    handleCiviiStatusChange(commit, "N", timeout)
                })
            }
        },
        async initStore ({commit, dispatch}) {
            if (window.civiiConf.alwaysReset) {
                window.civii.clear()
            }

            commit('resetWeakUnderstandingResponses');
            await dispatch('loadInfoFromStorage')
            window.dispatchEvent( new CustomEvent('civii-check-loggeado') );

            // se inicia el taskScheduler para evitar errores en sus llamadas
            commit('setTaskSch', new TaskScheduler({
                targetFunc () {
                let msgs = window.civiiConf.bubbleMessages
                dispatch('showBubbleMessage', {message: msgs[Math.floor(Math.random() * msgs.length)]})
                },
                intervalTime: window.civiiConf.bubbleMessageInterval
            }))

            if (window.civiiConf.showBubbleMessages) {
                dispatch('initBubbleMessages')
            }
            if (window.civiiConf.openAtStart) {
                dispatch('chatState', true)
            }
        },
        async chatState ({commit, state, dispatch}, value) {
            if (value && state.firstTime) {
                commit('setFirstTime', false)
                await dispatch('sendMessage', {message: '', welcome: true})
            }
            dispatch('isfirstBubble')
            if (value === false) {
                state.taskSch.start()
            } else {
                state.taskSch.reset()
            }
            commit('setChatState', value)
        },
        isfirstBubble ({state, commit}) {
            if (!state.firstBubbleClosed) {
                commit('setFirstBubbleClosed', true)
                clearTimeout(initialTimeoutID)
                commit('setBubbleMessage', null)
                state.taskSch.reset()
                state.taskSch.start()
            }
        },
        async testWorkspace ({dispatch, commit}, jsonURL) {
            testWorkspace(dispatch, commit, axios, jsonURL)
        },
        async sendMessage ({state, commit}, {message, textShowed, welcome, token}) {
            await new Promise( (resolve, reject) => {
                window.dispatchEvent( new CustomEvent('civii-check-loggeado') );
                setTimeout( resolve, 50 );
            });

            let res
            // context from input message
            let context = state.context

            /* messages can be sent via message or via _input in the context, the first
            is only text and the second is for any json object. If _input is not in
            the context and is not the first message, the string input should not be
            empty. Following if block checks this. */
            if (!welcome && context._input == null) {
                if (message == null || (typeof message === 'string' &&
                message.trim() === '')) return
            }

            if (message != null && message.trim() !== '') {
                message = message.trim()
                if (textShowed == null) textShowed = message

                commit('addMessage', {
                    type: 'Normal',
                    side: 'right',
                    messages: [{ text: textShowed }]
                })
            }

            /* widgets are emptied to ensure they don't show when message is being
            sent to watson */
            commit('setButtons', [])
            commit('setAccordionChecklist', {})
            commit('setCalendarWidget', null)
            commit('setCancelAccept', null)
            commit('setCameraWidget', null)
            commit('setUploadWidget', null)

            /* when loading is true, entire app knows civii is busy, and shows for
            ellipsis message. disableInput is used to block input when required */
            commit('setLoading', true)
            commit('setDisableInput', false)

            let skipWatson = false

            /* Checks if there are still site actions to be executed before input is sent
            to watson, this way simple logic (without natural language processing)
            can be executed without calling watson */
            if (context.actions == null || (context.actions != null &&
                !context.actions.hasOwnProperty('before')
            )) {
                let chatbotDTO = {message, contexto: state.context, requestToken: token}

                /* from watson, admins can set site actions to be called after input is
                provided by the user and before it is sent to watson */
                if (context.actions != null && context.actions.hasOwnProperty('after')) {
                if (typeof context.actions.after === 'string') {
                    context.actions.after = [context.actions.after]
                }
                let actionsList = JSON.parse(JSON.stringify(context.actions.after))
                chatbotDTO = await executeActions({
                    actionsList, output: chatbotDTO, commit, actions: this._vm.$actions})
                }
                skipWatson = chatbotDTO.skipWatson || false

                if (!skipWatson) {
                    // sends message to watson
                    try {
                        res = await axios.post(window.civiiConf.baseURL +
                        '/civii/Chatbot/Conversemos/' + window.civiiConf.workspace, chatbotDTO)
                        .then(response => {

                            if(response.data.estadoCivii){
                                let isCiviiActive = response.data.estadoCivii.active
                                if(isCiviiActive == "N"){
                                    handleCiviiStatusChange(commit, isCiviiActive, window.civiiConf.onTurnedOffStatusTimeout)
                                }
                            }

                            if(response.data.message && response.data.message !== ""){
                                let rawIntents = response.data.intents || '[]';
                                checkWeakUnderstanding(commit, rawIntents);
                            }

                            return response
                        })
                    } catch (err) {
                        console.error(err)
                        commit('addMessage', {
                            type: 'Normal',
                            side: 'left',
                            messages: [
                                { text: window.civiiConf.serverErrorMessage }
                            ]
                        })
                        commit('setLoading', false)
                        return false
                    }
                }
            } else {
                /* If watson is not called, watson response must be created empty, and
                site actions have to fill it */
                skipWatson = true
            }

            if (skipWatson) {
                await (() => new Promise(resolve => setTimeout(resolve, 1000)))()
                res = {
                data: {
                    contexto: context,
                    outputWatson: {
                        json_response: []
                    },
                    input: message
                }
                }
            }

            let data = res.data

            context = data.contexto
            if (data.outputWatson.json_response == null) {
                data.outputWatson.json_response = []
            }

            /* Admins in watson can set actions to be executed before showing response
            to the user */
            if (context.actions != null && context.actions.hasOwnProperty('before')) {
                if (typeof context.actions.before === 'string') {
                    context.actions.before = [context.actions.before]
                }
                let actionsList = JSON.parse(JSON.stringify(context.actions.before))
                data = await executeActions({actionsList, output: data, commit, actions: this._vm.$actions})
                data.outputWatson.json_response = fillPlaceholdersJson(data.outputWatson.json_response, context)
            }

            let output = data.outputWatson

            if (output.json_response == null) {
                output.json_response = []
            }

            /* specific messages saved in js config file can be set by watson admins,
            to be shown to the user */
            if (output.saved_answer) {
                output = window.civiiConf.saved_answers[output.saved_answer]
            }

            // add response to chat
            if (Array.isArray(output.json_response)) {
                if(state.weakUnderstandingResponses >= window.civiiConf.civiiChat.weakUnderstandingAttemps){
                    output.json_response.push(
                        {
                            type: 'Normal',
                            side: 'left',
                            messages: [
                                { text: window.civiiConf.civiiChat.imLostMessage }
                            ]
                        }
                    );

                    output.buttons = null;
                    output.accordion_checklist = null;
                    output.calendarWidget = null;
                    output.cameraWidget = null;
                    output.uploadWidget = null;

                    output.cancelAccept = true
                    if(data.contexto.actions) {
                        data.contexto.actions.before  = ['civiiChat.quieroHablarConAgente']
                    } else {
                        data.contexto.actions = {
                            before: ['civiiChat.quieroHablarConAgente']
                        }
                    }
                }
                for (let message of output.json_response) {
                    commit('addMessage', message)
                }
            }

            // check if watson requested a widget to be shown, and set it up
            let buttons = output.buttons
            if (buttons == null) buttons = []
            // else if (message.length > 0) state.messagesStack.push(message)

            let accordionChecklist = output.accordion_checklist
            if (accordionChecklist == null) accordionChecklist = {}

            let calendarWidget = output.calendarWidget
            if (calendarWidget == null) calendarWidget = null

            let cancelAccept = output.cancelAccept
            if (cancelAccept == null) cancelAccept = null

            let cameraWidget = output.cameraWidget
            if (cameraWidget == null) cameraWidget = null

            let uploadWidget = output.uploadWidget
            if (uploadWidget == null) uploadWidget = null

            let disableInput = output.disableInput
            if (disableInput == null) disableInput = false

            // if config option restartAfterLastInteraction is not null, civii is
            // restarted after time set in restartAfterLastInteraction has elapsed
            let restartAfterLastInteraction = output.restartAfterLastInteraction ||
                window.civiiConf.restartAfterLastInteraction || null
            clearTimeout(lastMsgTimeoutId)
            if (!welcome && restartAfterLastInteraction != null &&
                typeof restartAfterLastInteraction === 'number') {
                lastMsgTimeoutId = setTimeout(() => window.civii.restart(),
                restartAfterLastInteraction)
            }

            commit('setButtons', buttons)
            commit('setAccordionChecklist', accordionChecklist)
            commit('setCalendarWidget', calendarWidget)
            commit('setCancelAccept', cancelAccept)
            commit('setCameraWidget', cameraWidget)
            commit('setUploadWidget', uploadWidget)

            // update context
            commit('setContext', data.contexto)

            commit('setDisableInput', disableInput)
            commit('setLoading', false)

            /* from watson, the "ask me again" can be set to ask user if he/she wants
                to see the first message of a menu */
            // let askMeAgain = output.ask_me_again
            // if (typeof askMeAgain === 'boolean' && askMeAgain === true) {
            //   if (state.messagesStack.length > 0) {
            //     commit('addMessage', {
            //       type: 'Normal',
            //       side: 'left',
            //       messages: [
            //         { text: '¿Desea volver a solicitarme: "' + state.messagesStack[0] + '"' }
            //       ]
            //     })
            //     commit('setButtons', [{message: state.messagesStack[0],
            //       text: 'Volver a solicitar: ' + state.messagesStack[0]}])
            //     state.messagesStack = []
            //   } else {
            //     let msgs = window.civiiConf.askMoreMessages
            //     commit('addMessage', {
            //       type: 'Normal',
            //       side: 'left',
            //       messages: [
            //         { text: msgs[Math.floor(Math.random() * msgs.length)] }
            //       ]
            //     })
            //   }
            // }

            return true
        },
        async loadInfoFromStorage ({commit, dispatch}) {
            // load context
            let context = localStorage.getItem('civiiContext')
            if (context !== null) commit('setContext', JSON.parse(context))
            else commit('setContext', {})

            // load messages and find out if civii should show the welcome message
            let messages = localStorage.getItem('civiiMessages')
            if (messages === null) {
                commit('setContext', {})
                commit('setFirstTime', true)
                commit('setMessages', {value: [], noLocalStorage: true})
            } else commit('setMessages', {value: JSON.parse(messages)})

            // load buttons
            let buttons = localStorage.getItem('civiiButtons')
            if (buttons !== null) commit('setButtons', JSON.parse(buttons))
            else commit('setButtons', [])

            // load accordionChecklist
            let accordionChecklist = localStorage.getItem('civiiAccordionChecklist')
            if (accordionChecklist !== null) commit('setAccordionChecklist', JSON.parse(accordionChecklist))
            else commit('setAccordionChecklist', {})

            // load calendarWidget
            let calendarWidget = localStorage.getItem('civiiCalendarWidget')
            if (calendarWidget !== null) commit('setCalendarWidget', JSON.parse(calendarWidget))
            else commit('setCalendarWidget', null)

            // load CancelAccept
            let cancelAccept = localStorage.getItem('civiiCancelAccept')
            if (cancelAccept !== null) commit('setCancelAccept', JSON.parse(cancelAccept))
            else commit('setCancelAccept', null)

            // load CameraWidget
            let cameraWidget = localStorage.getItem('civiiCameraWidget')
            if (cameraWidget !== null) commit('setCameraWidget', JSON.parse(cameraWidget))
            else commit('setCameraWidget', null)

            // load UploadWidget
            let uploadWidget = localStorage.getItem('civiiUploadWidget')
            if (uploadWidget !== null) commit('setUploadWidget', JSON.parse(uploadWidget))
            else commit('setUploadWidget', null)

            // load CancelAccept
            let disableInput = localStorage.getItem('civiiDisableInput')
            if (disableInput !== null) commit('setDisableInput', JSON.parse(disableInput))
            else commit('setDisableInput', false)

            // load state of the chat (if minimized or not)
            let chatIsOpen = localStorage.getItem('civiiIsOpen')
            if (chatIsOpen !== null) commit('setChatState', chatIsOpen === 'true')
            else commit('setChatState', false)

            // load if sound is on or off
            let sound = localStorage.getItem('civiiSound')
            if (sound !== null) commit('setSound', sound === 'true')
            else commit('setSound', true)

            // load if a link was opened with target=_self
            let selfLinkClicked = localStorage.getItem('civiiSelfLinkClicked')
            if (selfLinkClicked !== null) commit('setSelfLinkClicked', selfLinkClicked === 'true')
            else commit('setSelfLinkClicked', false)

            // load if the first bubble message from civii has been closed before
            let firstBubbleClosed = localStorage.getItem('civiiFirstBubbleClosed')
            if (firstBubbleClosed !== null) commit('setFirstBubbleClosed', firstBubbleClosed === 'true')
            else commit('setFirstBubbleClosed', false)

            commit('setBubbleMessage', null)

            // if there is contextoApps variable in sessionStorage, add it to context
            dispatch('updateFromContextoApps')
        },
        updateFromContextoApps ({commit}) {
            let contextoApps = sessionStorage.getItem('contextoApps')
            if (contextoApps){
                commit('addToContext', JSON.parse(contextoApps))
            }
        },
        async bubbleMessageAfterClose ({commit}) {
            commit('setSelfLinkClicked', true)
            localStorage.setItem('civiiBubbleMessage', window.civiiConf.bubbleMessageAfterClose)
        },
        async showBubbleMessage ({commit, dispatch}, {message, time}) {
            if (time == null){
                time = window.civiiConf.bubbleMessageTime
            }
            commit('setBubbleMessage', message)
            setTimeout(function () {
                commit('setBubbleMessage', null)
            }, time)
        },
        initBubbleMessages ({state, commit, dispatch}) {
            clearTimeout(initialTimeoutID)
            if (state.taskSch === null) {
                commit('setTaskSch', new TaskScheduler({
                targetFunc () {
                    let msgs = window.civiiConf.bubbleMessages
                    dispatch('showBubbleMessage', {message: msgs[Math.floor(Math.random() * msgs.length)]})
                },
                intervalTime: window.civiiConf.bubbleMessageInterval
                }));
            } else {
                state.taskSch.stop()
            }
            if (state.selfLinkClicked) {
                commit('setSelfLinkClicked', false)
                let firstMessage = localStorage.getItem('civiiBubbleMessage')
                commit('setBubbleMessage', firstMessage)
                initialTimeoutID = setTimeout(function () {
                    commit('setBubbleMessage', null)
                    state.taskSch.reset()
                    state.taskSch.start()
                }, window.civiiConf.bubbleMessageTime)
            } else if (!state.firstBubbleClosed) {
                let msgs = window.civiiConf.bubbleMessages
                let firstMessage = msgs[Math.floor(Math.random() * msgs.length)]
                commit('setBubbleMessage', firstMessage)
                initialTimeoutID = setTimeout(function () {
                    commit('setBubbleMessage', null)
                    state.taskSch.reset()
                    state.taskSch.start()
                }, window.civiiConf.bubbleMessageDelay);
            } else {
                state.taskSch.start()
            }
        }
    },
    modules: {
        civiiChat: civiiChatStore
    }
}



// WEBPACK FOOTER //
// ./src/store/baseStore.js